import { createAnalyticsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const AnalyticsService = createAnalyticsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
